import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 16.928 16.928"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #292A2E)",
      d: "M7.5 0C11.64 0 15 3.36 15 7.5S11.64 15 7.5 15 0 11.64 0 7.5 3.36 0 7.5 0m0 13.333A5.83 5.83 0 0 0 13.333 7.5 5.83 5.83 0 0 0 7.5 1.667 5.83 5.83 0 0 0 1.667 7.5 5.83 5.83 0 0 0 7.5 13.333m7.07.06 2.358 2.356-1.179 1.18-2.357-2.358z"
    }, null, -1)
  ]))]))
}
export default { render: render }